module.exports = __webpack_public_path__ + "media/Q1.826cdb59.mp4";